import React, { Fragment, FunctionComponent } from "react";
import {
  SpinNumberInputField,
  FieldArray,
  FieldItemError,
  FieldSpy,
  Heading,
  HideStack,
  NoDataTile,
  Separator,
  Stack,
  Text,
  useFieldContext
} from "@bps/fluent-ui";
import { Tenant } from "@libs/api/gateways/plt/plt-gateway.dtos";

interface ChildTenantsListFieldProps {
  tenant: Tenant;
}

export const ChildTenantsListField: FunctionComponent<ChildTenantsListFieldProps> = ({
  tenant
}) => {
  const { value: salesProductId } = useFieldContext("salesProductId");
  const { meta } = useFieldContext("items");

  if (!salesProductId) {
    return (
      <NoDataTile
        textProps={{ text: "No product selected!" }}
        linkProps={{ hidden: true }}
        showBoxShadow={false}
      />
    );
  }

  return (
    <HideStack when={!salesProductId}>
      {meta?.error && (
        <FieldItemError
          name="items"
          errorMessage={meta?.error}
          styles={{ root: { paddingBottom: 16 } }}
        />
      )}

      <FieldArray name="items">
        {names => (
          <>
            {names.map(name => (
              <Fragment key={name}>
                <Stack horizontal horizontalAlign="space-between">
                  <Stack>
                    <FieldSpy name={name}>
                      {value => (
                        <>
                          <Heading>{value?.childTenantName}</Heading>
                          <Text variant="small">{value?.childTenantId}</Text>
                          <Text variant="small">{value?.application}</Text>
                        </>
                      )}
                    </FieldSpy>

                    <Text variant="small">{tenant.crmId}</Text>
                  </Stack>
                  <SpinNumberInputField
                    name={`${name}.quantity`}
                    styles={{ root: { width: 50 } }}
                  />
                </Stack>
                <Separator />
              </Fragment>
            ))}
          </>
        )}
      </FieldArray>
    </HideStack>
  );
};
